import { OneClick } from '@/components/blocks/OneClick';
import { Box } from '@mui/material';
import { MouseEvent } from 'react';
import { actionItemSX, actionsSX } from '@/components/blocks/EmailRecommendedCouponPopup/styles';

interface PopupActionsProps {
	onAddToCart: (event: MouseEvent<HTMLButtonElement>) => void;
	onGoToCheckout: (event: MouseEvent<HTMLButtonElement>) => void;
	disabled?: boolean;
	isLoggedIn: boolean;
}

export const PopupActions = ({ onAddToCart, disabled = false, isLoggedIn }: PopupActionsProps) => (
	<Box sx={actionsSX}>
		<Box sx={actionItemSX}>
			<OneClick variant="contained" onClick={onAddToCart} disabled={disabled}>
				{!isLoggedIn ? 'Iniciar sesión y activar cupón' : 'Agregar al carrito'}
			</OneClick>
		</Box>
	</Box>
);
